import axios from 'axios';
import { EnvironmentVariables, getEnvironmentVariable } from '../env/environment.service.ts';
import { ServerErrorResponse } from '@Types/types.ts';
import { handleServerError } from '../errors/error.service.ts';
import { useBoundStore } from '@Store/index.ts';

export const HttpService = axios.create({
  withCredentials: true,
  baseURL: getEnvironmentVariable(EnvironmentVariables.VITE_BASE_URL),
});

HttpService.interceptors.request.use((config) => {
  const captchaKey = window.sessionStorage.getItem('captchaToken');
  const accessToken = useBoundStore.getState().customer.accessToken;
  const isEmbedded = useBoundStore.getState().onboardingSlice.getIsEmbedded();

  if (captchaKey) {
    config.headers['recaptcha'] = captchaKey;
  }
  if (accessToken) {
    if (isEmbedded) {
      config.headers['Authorization'] = `lili ${accessToken}`;
    } else {
      config.headers['Authorization'] = `Bearer ${accessToken}`;
    }
  }
  return config;
});

HttpService.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  },
  function (error: ServerErrorResponse) {
    const errorCode = error?.response?.data?.errors?.[0]?.code || 0;
    const localizedErrorMessage = error?.response?.data?.errors?.[0]?.localizedMessage;
    handleServerError(errorCode, localizedErrorMessage);
    return Promise.reject(error);
  }
);
